/** @format */

import { END_POINT } from "utils";
import { deleteRequest, getRequest, patchRequest, postRequest } from "./axios";
import type { WmsItemGroup } from "types";

let cachedWmsItemGroups: WmsItemGroup[] | null = null;
let inflight: Promise<WmsItemGroup[]> | null = null;

export const wmsItemGroupService = {
  list: async (): Promise<WmsItemGroup[]> => {
    if (cachedWmsItemGroups) return cachedWmsItemGroups;
    if (inflight) return inflight;

    inflight = getRequest(END_POINT.WMS_ITEM_GROUPS.LIST)
      .then((rs) => rs.data?.data ?? rs.data ?? [])
      .catch(() => [])
      .finally(() => {
        inflight = null;
      });

    cachedWmsItemGroups = await inflight;
    return cachedWmsItemGroups;
  },
  create: async (payload: WmsItemGroup) => {
    const rs = await postRequest(END_POINT.WMS_ITEM_GROUPS.LIST, payload);
    cachedWmsItemGroups = null;
    return rs.data;
  },
  update: async (id: number | string, payload: WmsItemGroup) => {
    const rs = await patchRequest(`${END_POINT.WMS_ITEM_GROUPS.LIST}/${id}`, payload);
    cachedWmsItemGroups = null;
    return rs.data;
  },
  destroy: async (id: number | string) => {
    const rs = await deleteRequest(`${END_POINT.WMS_ITEM_GROUPS.LIST}/${id}`);
    cachedWmsItemGroups = null;
    return rs.data;
  },
};
